import {RefObject, useEffect, useState} from "react";

interface IProps {
    data: unknown[];
    tableRef: RefObject<HTMLDivElement | null>;
    tableRowsRef: RefObject<HTMLDivElement | null>;
}

export const useShowScrollButtons = (props: IProps) => {
    const [showScrollButtons, setShowScrollButtons] = useState(false);

    const getMarginLeft = (element?: HTMLElement | null) => {
        return element ? parseFloat(window.getComputedStyle(element).getPropertyValue("margin-left")) : 0;
    };

    useEffect(() => {
        if (props.tableRef.current && props.tableRowsRef.current && props.data.length > 0) {
            const resizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => {
                    const rowsMarginLeft = getMarginLeft(props.tableRowsRef.current);
                    const rowsWidth = (props.tableRowsRef.current?.firstElementChild as HTMLElement)?.offsetWidth || 0;
                    const tableWidth = props.tableRef.current?.offsetWidth || 0;

                    setShowScrollButtons(rowsWidth + rowsMarginLeft > tableWidth);
                });
            });
            resizeObserver.observe(document.body);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [props.data.length, props.tableRef.current]);

    return showScrollButtons;
};
import {RefObject, useEffect, useState} from "react";

interface IProps {
    data: unknown[];
    tableRef: RefObject<HTMLDivElement | null>;
    tableRowsRef: RefObject<HTMLDivElement | null>;
}

export const useShowScrollButtons = (props: IProps) => {
    const [showScrollButtons, setShowScrollButtons] = useState(false);

    const getMarginLeft = (element?: HTMLElement | null) => {
        return element ? parseFloat(window.getComputedStyle(element).getPropertyValue("margin-left")) : 0;
    };

    useEffect(() => {
        if (props.tableRef.current && props.tableRowsRef.current && props.data.length > 0) {
            const resizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => {
                    const rowsMarginLeft = getMarginLeft(props.tableRowsRef.current);
                    const rowsWidth = (props.tableRowsRef.current?.firstElementChild as HTMLElement)?.offsetWidth || 0;
                    const tableWidth = props.tableRef.current?.offsetWidth || 0;

                    setShowScrollButtons(rowsWidth + rowsMarginLeft > tableWidth);
                });
            });
            resizeObserver.observe(document.body);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [props.data.length, props.tableRef.current]);

    return showScrollButtons;
};
